import isNil from 'lodash/isNil'

import { DocumentType, Maybe, MiDocumentSummary } from '../../generated/resolvers'

// BE returns string for miDocument `inference_result.type` field
// but it's value could only be either null, empty string or one of the DocumentType
// So the type of this field could be DocumentType in FE but we need to resolve '' to InvalidDocumentType
export const formatInferenceResultType = (inferenceResultType: Maybe<string>): Maybe<DocumentType> => {
  if (isNil(inferenceResultType)) return inferenceResultType
  if (inferenceResultType === '') return DocumentType.InvalidDocumentType
  return inferenceResultType as DocumentType
}

export const formatMIDocument = (miDocument: MiDocumentSummary): MiDocumentSummary => {
  return {
    ...miDocument,
    inference_result: {
      ...miDocument.inference_result,
      type: formatInferenceResultType(miDocument.inference_result?.type),
    },
  }
}

